import React from 'react';
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { Stack, Typography } from '@mui/material';
import { DiscountTypes } from 'api';
import { FormCard, FormInput } from 'components';
import { PercentOutlined } from '@mui/icons-material';
import { dataInitialSelectsOptions } from '../../../fields';
import CollectionsInput from '../CollectionsInput';

interface Props {
  control: Control<DiscountTypes.ItemCreateParams> | undefined;
  watch: UseFormWatch<DiscountTypes.ItemCreateParams>;
  setValue: UseFormSetValue<DiscountTypes.ItemCreateParams>;
  initialSelectsOptions:
    | ReturnType<typeof dataInitialSelectsOptions>
    | undefined;
}

const QuantityDiscount: React.FC<Props> = (props: Props): JSX.Element => {
  const { control, watch, setValue, initialSelectsOptions } = props;

  return (
    <FormCard title="Settings">
      <Stack spacing={2}>
        <CollectionsInput
          name="metafields_attributes.0.value.selectCollection"
          control={control}
          watch={watch}
          initialValue={initialSelectsOptions?.metafieldsCollections}
          onChange={(value) => {
            const ids = value.map((v) => v.id);
            setValue(
              'metafields_attributes.0.value.selectedCollectionIds',
              ids,
            );
          }}
        />

        <FormInput
          control={control}
          name="metafields_attributes.0.value.percent_off_on_collection"
          inputType="number"
          label="Paid item discount percentage"
          tooltip="Applies only to eligible items that remain paid after the free item offer is calculated. Leave at 0% if you only want the free item offer."
          InputProps={{
            endAdornment: <PercentOutlined fontSize="small" />,
          }}
          rules={{
            onBlur: (e) =>
              setValue(
                'metafields_attributes.0.value.percent_off_on_collection',
                +(+e.target.value).toFixed(2),
              ),
          }}
        />

        <Typography variant="subtitle2">Free item offer</Typography>

        <FormInput
          control={control}
          name="metafields_attributes.0.value.buy_x"
          inputType="number"
          label="Buy quantity"
        />

        <FormInput
          control={control}
          name="metafields_attributes.0.value.get_y"
          inputType="number"
          label="Free quantity"
        />

        <FormInput
          control={control}
          name="metafields_attributes.0.value.incremental_buy_x_get_y"
          inputType="checkbox"
          label="Repeat the offer for every threshold met"
          helperText="When enabled, every additional buy quantity awards more free items. When disabled, the discount awards free items only once per order."
        />

        <FormInput
          control={control}
          name="metafields_attributes.0.value.mix_and_match"
          inputType="switch"
          label="Mix and match"
          onChange={(e) => {
            const target = e.target as HTMLInputElement;
            const { checked } = target;
            setValue('metafields_attributes.0.value.mix_and_match', checked);
            setValue('metafields_attributes.0.value.mixmatch', checked);
          }}
        />
      </Stack>
    </FormCard>
  );
};

export default QuantityDiscount;
